import React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { formActions } from "../../../store/actions/cms/form/form.action";

class ConfirmationSelect extends React.Component {
  handleChange = (selectedConf) => {
    const { dispatch, emails, form, type, pages } = this.props;

    if (type === "EMAIL") {
      if (selectedConf.value) {
        let selected = emails.find((t) => {
          return t.comContentId === selectedConf.value;
        });
        if (selected) {
          dispatch(formActions.softUpdate({ ...form, emailConfirmationId: selected.comContentId }));
          return;
        }
      }
      dispatch(formActions.softUpdate({ ...form, emailConfirmationId: null }));
    } else if (type === "WEB") {
      if (selectedConf.value) {
        let selected = pages.find((t) => {
          return t.id === selectedConf.value;
        });
        if (selected) {
          dispatch(formActions.softUpdate({ ...form, pageConfirmationId: selected.id }));
          return;
        }
      }
      dispatch(formActions.softUpdate({ ...form, pageConfirmationId: null}));
    }
  };
  render() {
    const { form, emails, type, pages } = this.props;
    const selectedWebConf =
      pages !== undefined &&
      pages.find((t) => {
        return t.id === form.pageConfirmationId;
      });
    const selectedEmailConf =
      emails !== undefined &&
      emails.find((t) => {
        return t.comContentId === form.emailConfirmationId;
      });
    const emailOptions =
      emails?.map((t) => {
        return { value: t.comContentId, label: t.name };
      }) || [];
    emailOptions.unshift({ value: null, label: "-" });

    return (
      <React.Fragment>
        {pages && emails ? (
          <div>
            {type === "WEB" && (
              <div>
                {pages && (
                  <Select
                    options={pages.map((t) => {
                      return { value: t.id, label: t.name };
                    })}
                    classNamePrefix="jirango-select"
                    className="jirango-select"
                    value={selectedWebConf ? { value: selectedWebConf.id, label: selectedWebConf.name } : null}
                    onChange={this.handleChange}
                  />
                )}
              </div>
            )}
            {type === "EMAIL" && (
              <div>
                {emails && (
                  <Select
                    options={emailOptions}
                    classNamePrefix="jirango-select"
                    className="jirango-select"
                    value={selectedEmailConf ? { value: selectedEmailConf.comContentId, label: selectedEmailConf.name } : { value: null, label: "-" }}
                    onChange={this.handleChange}
                  />
                )}
              </div>
            )}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    form: state.form,
    emails: state.email.emails,
    pages: state.page.paths,
  };
}

export default connect(mapStateToProps)(ConfirmationSelect);
